// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__fTzRK","meals-appear":"AvailableMeals_meals-appear__-qRVr"};